import loadBrandListerSubModule from './modules/BrandLister.module';
const loadBrandListerModule = (initialData) => ({
    hasRouter: true,
    modules: [loadBrandListerSubModule(initialData)],
});
export default loadBrandListerModule;
